import { AddressInputConfig } from '../DataInputs/AddressInput/AddressInput';
import { CaptchaConfig } from './Captcha/Captcha';
import { CheckboxInputConfig } from './CheckboxInput/CheckboxInput';
import { CountySelectorConfig } from './CountySelector/CountySelector';
import { DateInputConfig } from '../DataInputs/DateInput/DateInput';
import { EmailInputConfig, EmailInputWithMatchConfig } from './EmailInput/EmailInput';
import { MoneyInputConfig } from './MoneyInput/MoneyInput';
import { PasswordInputConfig, PasswordInputWithStrengthConfig } from './PasswordInput/PasswordInput';
import { PhoneInputConfig } from '../DataInputs/PhoneInput/PhoneInput';
import { RadioGroupInputConfig } from './RadioGroupInput/RadioGroupInputWrapper';
import { SSNInputConfig } from '../DataInputs/SSNInput/SSNInput';
import { SelectInputConfig } from './SelectInput/SelectInput';
import { SimpleTextInputConfig } from '../DataInputs/SimpleTextInput/SimpleTextInput';
import { StateInputConfig } from '../DataInputs/StateInput/StateInput';
import { RequirementInputConfig } from './RequirementInput/RequirementInput';
import { SSNVerificationInputConfig } from './UnformattedNumberInput/UnformattedNumberInput';
import { UnformattedRequirementInputConfig } from './RequirementInput/UnformattedRequirementInput';
import { ZipCodeInputConfig } from '../DataInputs/ZipCodeInput/ZipCodeInput';

interface InputMap {
  [InputName: string]: FormInputConfig;
}

const InputMap: InputMap = {
  AddressInput: AddressInputConfig,
  Captcha: CaptchaConfig,
  CheckboxInput: CheckboxInputConfig,
  CountySelector: CountySelectorConfig,
  DateInput: DateInputConfig,
  EmailInput: EmailInputConfig,
  EmailInputWithMatch: EmailInputWithMatchConfig,
  MoneyInput: MoneyInputConfig,
  PasswordInput: PasswordInputConfig,
  PasswordInputWithStrength: PasswordInputWithStrengthConfig,
  PhoneInput: PhoneInputConfig,
  RadioGroupInput: RadioGroupInputConfig,
  SelectInput: SelectInputConfig,
  SimpleTextInput: SimpleTextInputConfig,
  SSNInput: SSNInputConfig,
  SSNVerificationInput: SSNVerificationInputConfig,
  StateInput: StateInputConfig,
  RequirementInput: RequirementInputConfig,
  UnformattedRequirementInput: UnformattedRequirementInputConfig,
  ZipCodeInput: ZipCodeInputConfig,
};

export default InputMap;
